export const HIDDEN_BESIDE_HERO_ASK = "[:root:has([data-hero-ask=in-view])_&]:hidden";
export const SHOWN_BESIDE_HERO_ASK = "[:root:has([data-hero-ask=in-view])_&]:block";
export const HIDDEN_BESIDE_LISTING_SEARCH = "[:root:has([data-listing-search])_&]:hidden";
